import React, { Component } from 'react';
import './CollapsibleSection.css';

class CollapsibleSection extends Component {
  constructor(props) {
    super(props);
    // Sections default to expanded unless defaultExpanded={false} is passed
    this.state = {
      isExpanded: props.defaultExpanded !== undefined ? props.defaultExpanded : true
    };
  }

  toggleExpand = () => {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }));
  };

  render() {
    const { title, children } = this.props;
    const { isExpanded } = this.state;

    return (
      <div className="collapsible-container">
        
        {/* Clickable Header */}
        <div 
          className={`collapsible-header ${isExpanded ? 'expanded' : ''}`}
          onClick={this.toggleExpand}
        >
          <span className="collapsible-icon">
            {isExpanded ? '▼' : '▶'}
          </span>
          <h2 className="collapsible-title">
            {title}
          </h2>
        </div>

        {/* Conditionally Rendered Content */}
        {isExpanded && (
          <div className="collapsible-content">
            {children}
          </div>
        )}

      </div>
    );
  }
}

export default CollapsibleSection;